import { useAppDispatch, useAppSelector } from "../../app/hooks";
import classes from "./BtcUserDk.module.css";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  Stack,
  TextField,
} from "@mui/material";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { selectBtcConfig, setBtcConfig, updateBtcConfig } from "../../features/btc/btcSlice";
import {
  getBtcQuy,
  updateBtcQuy,
  createBtcQuy,
  getDefaultConfig,
} from "../../services/btc/btcApi";
import AddIcon from "@mui/icons-material/Add";

import { BtcTitle, MyBtcLayout, theme } from "./BtcAdmin.js";
import { LularDatePicker } from "./ngayAl.js";
import { getLunarMonthStartEnd } from "./ngayAl.js";
import { ConfirmButton } from "../dialog/ConfirmButton.js";

import { collection, query, where, onSnapshot, Timestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import CloseIcon from '@mui/icons-material/Close';
import { selectGrp } from "../../features/auth/authSlice";
import { useSearchParams } from "react-router-dom";

const EditForm = ({
  quy,
  onOk,
  onClose = () => { },
  title,
  init = false,
  isEdit = false,
}) => {
  // const [open, setOpen] = useState(init);
  const open = init;
  const handleClose = () => {
    // setOpen(false);
    onClose();
  };

  const [editingObj, seteditedObj] = useState(quy);
  function handleChange(key, value) {
    console.log(key, value);
    seteditedObj({ ...editingObj, [key]: value });
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => { }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent style={{ padding: "0.5rem" }}>
          <Stack direction={"column"} spacing={2}>
            {/* <InputLabel id="quy-label">Ms Quỹ</InputLabel> */}
            <TextField
              label="Ms Quỹ"
              value={editingObj.msQuy}
              onChange={(e) => handleChange("msQuy", e.target.value)}
            ></TextField>
            {/* <InputLabel id="quy-label">Tên Quỹ</InputLabel> */}
            <TextField
              label="Tên Quỹ"
              value={editingObj.tenQuy}
              onChange={(e) => handleChange("tenQuy", e.target.value)}
            ></TextField>
            {/* <TextField
              label="Thành phần"
              style={{ width: "120px" }}
              value={editingObj.tp}
              onChange={(e) => handleChange("tp", e.target.value)}
            /> */}
            <FormControl sx={{ m: 1, width: 220 }}>
              <InputLabel id="demo-multiple-checkbox-label">
                {"Thành phần"}
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={editingObj.tp.split(",")}
                onChange={(e) => handleChange("tp", e.target.value.join(","))}
                input={<OutlinedInput label={"Thành phần"} />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {["A", "B", "C"].map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox
                      checked={editingObj.tp.split(",").includes(name)}
                    />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <Stack spacing={2} direction={"row"}>
              <Checkbox
                onChange={(e) => handleChange("private", e.target.checked)}
                checked={editingObj.private}
              ></Checkbox>
              <Typography>{"Quản lý"}</Typography>
            </Stack> */}
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="demo-select-small-label">{"Quản lý"}</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={editingObj.private}
                label="Quản lý"
                onChange={(e) => handleChange("private", e.target.value)}
              >
                <MenuItem value={true}>TRUE</MenuItem>
                <MenuItem value={false}>FALSE</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="outlined-multiline-static"
              label="Ghi chú"
              multiline
              value={editingObj.note}
              variant="outlined"
              minRows={3}
              fullWidth
              onChange={(e) => handleChange("note", e.target.value)}
            ></TextField>
          </Stack>
        </DialogContent>
        {true && (
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
                onOk(editingObj);
              }}
              autoFocus
            >
              {isEdit ? "Lưu" : "Thêm mới"}
            </Button>
            <Button onClick={handleClose}>{"Hủy"}</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const BtcQuy = ({ navigate, params = {} }) => {
  
  console.log("BtcQuy: ", params);

  const isDefault = params?.id === "default";
  
  const dispatch = useAppDispatch();

  const btcConfig = useAppSelector(selectBtcConfig);
  const grp = useAppSelector(selectGrp);

  const [note, setNote] = useState("");
  const [month, setMonth] = useState(() => {
    const [startDt, endDt] = getLunarMonthStartEnd();
    // console.log(startDt)
    return startDt;
  });
  const [editingQuy, setEditingQuy] = useState(null);
  const [creating, setCreateState] = useState(false);
  const orgDsQuy = btcConfig.dsQuy;
  const [dsQuy, setDsQuy] = useState(btcConfig.dsQuy);
  const ngay = isDefault? "default" : month.format("YYYY-MM-DD");
  const [defaultDsQuy, setDefaultDsQuy] = useState();

  // snackbar
  const [openSB, setOpenSB] = useState(false);

  // subscribe
  useEffect(() => {
    const now = Timestamp.now();
    const q = query(
      collection(db, `btc/${grp}/quy_log`),
      where("timestamp", ">=", now)
    );

    console.log("[Subscribe] Start at:", now.toDate().toLocaleString());

    const unsubscribe = onSnapshot(
      q,
      { includeMetadataChanges: true },
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const { id: logId } = change.doc;
          const { json, action, itemId, timestamp } = change.doc.data();

          console.log(`QUY log: [${logId}] ${action} [${itemId}] at ${timestamp.toDate().toLocaleString()}`);
          console.log("content: ", json);

          if (ngay === itemId) {
            apply();
            console.log("applied");
          } else {
            console.log("skipped");
          }

          function apply() {
            try {
              const { dsQuy: dsQuyJson, ...changes } = JSON.parse(json);
              if (typeof dsQuyJson === "string") {
                changes.dsQuy = JSON.parse(dsQuyJson);
              }

              dispatch(updateBtcConfig({ ngay: itemId, ...changes }));
              if (typeof changes.note === "string") { setNote(changes.note); }
              if (typeof dsQuyJson == "string") { setDsQuy(changes.dsQuy); }
              setOpenSB({
                msg: "Đã cập nhật thay đổi: " + timestamp.toDate().toLocaleString(),
              });
            } catch (e) {
              console.error("[Realtime] JSON parse error:", e, json);
            }
          }
        });
      }
    );

    return () => {
      console.log("[Subscribe] Unsubscribed");
      unsubscribe();
    };
  }, [dispatch, grp, ngay]);

  // load data
  useEffect(() => {
    // let isMounted = true;

    const load = async () => {
      if (btcConfig.ngay === ngay) return;

      try {
        let { result, error } = await getBtcQuy({ ngay, grp });
        // if (!isMounted) return;

        if (result) {
          dispatch(setBtcConfig({ ...result, ngay }));
          setDsQuy(result.dsQuy);
          setNote(result.note);
          return;
        }

        console.warn("[Load] Not found:", error);

        // if "not found" use default config
        let quyCfg = { dsQuy: [] };
        if (error === "not found") {
          const fallback = await getBtcQuy({ ngay: "default", grp });
          // const fallback = await getDefaultConfig(grp);
          // if (!isMounted) return;
          if (fallback.result) {
            quyCfg = fallback.result;
            setDefaultDsQuy(fallback.result.dsQuy);
          }
        }

        dispatch(setBtcConfig({ ngay, dsQuy: [], note: "" }));
        setDsQuy(quyCfg.dsQuy);
        setNote("");

      } catch (e) {
        console.error("[Load] Error:", e);
      }
    };

    load();

    return () => {
      // isMounted = false;
    };
  }, [btcConfig.ngay, dispatch, grp, navigate, ngay]);

  function onAdd(createdDk) {
    var newDsQuy = dsQuy.concat(createdDk);
    newDsQuy.sort((a, b) =>
      a.msQuy > b.msQuy ? 1 : a.msQuy < b.msQuy ? -1 : 0
    );
    setDsQuy(newDsQuy);
    setCreateState(false);
  }
  function onSave(edited) {
    console.log("save quy", edited);
    var idx = dsQuy.indexOf(editingQuy);
    var newDsQuy = dsQuy.toSpliced(idx, 1, edited);
    newDsQuy.sort((a, b) =>
      a.msQuy > b.msQuy ? 1 : a.msQuy < b.msQuy ? -1 : 0
    );
    setDsQuy(newDsQuy);
    setEditingQuy(null);
  }
  function onCancel() {
    setEditingQuy(null);
  }
  function handleDelete(index) {
    setDsQuy(dsQuy.toSpliced(index, 1));
  }
  function handleEdit(index) {
    setEditingQuy(dsQuy[index]);
  }
  function handleAdd() {
    setCreateState(true);
  }

  const screenOrientation = 0; // 0:landscape
  function handleChange(idx, key, value) {
    console.log(key, value);
    var edited = { ...dsQuy[idx] };
    edited[key] = value;
    setDsQuy(dsQuy.toSpliced(idx, 1, edited));
  }
  async function handleSave() {
    if (created) {
      var { error, result } = await updateBtcQuy({ grp, ngay, dsQuy, note });
      if (error) {
        console.error(error);
        return;
      }
      dispatch(setBtcConfig({ ...result, ngay }));
    } else {
      ({ error, result } = await createBtcQuy({ grp, ngay, dsQuy, note }));
      if (error) {
        console.error(error);
        return;
      }
      dispatch(setBtcConfig({ ...result, ngay }));
    }
  }
  async function handleReset() {
    if (!defaultDsQuy) {
      var { result: defaultCfg } = await getDefaultConfig(grp);
      var quyCfg = { dsQuy: [] };
      if (defaultCfg) {
        quyCfg = JSON.parse(defaultCfg.defaultDsQuy);
        setDefaultDsQuy(quyCfg.dsQuy);
      }
      setDsQuy(quyCfg.dsQuy);
    } else {
      setDsQuy(defaultDsQuy);
    }
  }

  function compare() {
    return (
      note === btcConfig.note &&
      JSON.stringify(orgDsQuy) === JSON.stringify(dsQuy)
    );
  }
  const noChange = compare(orgDsQuy, dsQuy);
  const created = btcConfig.id;

  const title = <BtcTitle navigate={navigate}></BtcTitle>;
  const footer = (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Button onClick={handleReset}>{"Đặt lại"}</Button>
      <div>
        <Button onClick={handleSave} disabled={noChange}>
          {created ? "Lưu" : "Tạo mới"}
        </Button>
        <Button onClick={() => navigate(-1)}>{"Hủy"}</Button>
      </div>
    </div>
  );

  if (!Array.isArray(dsQuy)) {
    return <></>;
  }

  const handleCloseSB = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSB(false);
  };
  const action = (
    <>
      {/* <Button color="secondary" size="small" onClick={handleCloseSB}>
        UNDO
      </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSB}
      >
        <CloseIcon fontSize="small" />
      </IconButton></>
  );

  return (
    <MyBtcLayout title={title} footer={footer}>
      <Stack
        direction={"column"}
        spacing={{ xs: 1, sm: 2 }}
        style={
          screenOrientation
            ? { display: "flex", flexDirection: "column", height: "100%" }
            : {
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflow: "auto",
            }
        }
      >
        <div
          style={
            screenOrientation
              ? { flexGrow: 8, overflow: "auto" }
              : { flexGrow: 8 }
          }
        >
          <Stack direction={"column"} spacing={{ xs: 1, sm: 2 }}>
            {(isDefault) ? <Typography>Default</Typography> : <LularDatePicker setMonth={setMonth} month={month} />}
            {dsQuy.map((quy, quyIdx) => {
              return (
                <div
                  key={quyIdx}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className={`${classes.table_row} ${quyIdx % 2 ? classes.table_row2 : classes.table_row1
                    }`}
                >
                  {false &&
                    renderQuyGrid(
                      quy,
                      handleChange,
                      quyIdx,
                      handleEdit,
                      handleDelete
                    )}
                  {true &&
                    renderQuy(
                      quy,
                      handleChange,
                      quyIdx,
                      handleEdit,
                      handleDelete
                    )}
                </div>
              );
            })}
          </Stack>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "aliceblue",
            }}
          >
            <IconButton onClick={handleAdd} color="primary" size="large">
              <AddIcon></AddIcon>
            </IconButton>
          </div>
        </div>
        <div style={{ height: "200px" }}>
          <div style={{ margin: "0.5rem" }}>
            <Typography variant="h5">{"Tổng: " + dsQuy.length}</Typography>
          </div>

          <TextField
            id="outlined-multiline-static"
            label="Ghi chú"
            multiline
            value={note}
            variant="outlined"
            minRows={3}
            fullWidth
            onChange={(e) => setNote(e.target.value)}
          />
        </div>
      </Stack>
      {editingQuy && (
        <EditForm
          quy={editingQuy}
          onOk={onSave}
          onClose={onCancel}
          init={true}
          title={"Sửa lại Quỹ"}
          isEdit={true}
        />
      )}
      {creating && (
        <EditForm
          quy={{
            msQuy: "",
            tenQuy: "",
            note: "",
            tp: "A,B,C",
            private: false,
          }}
          onOk={onAdd}
          onClose={() => setCreateState(false)}
          init={true}
          title={"Thêm mới Quỹ"}
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={!!openSB}
        autoHideDuration={6000}
        onClose={handleCloseSB}
        message={openSB.msg}
        action={action}
      />
    </MyBtcLayout>
  );
};

export default BtcQuy;
function renderQuyGrid(quy, handleChange, quyIdx, handleEdit, handleDelete) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 4 }}>
        <Stack direction={"row"}>
          <TextField
            label="Ms Quỹ"
            style={{ width: "120px" }}
            value={quy.msQuy}
            onChange={(e) => handleChange(quyIdx, "msQuy", e.target.value)}
          />
          <div style={{ width: "1rem" }}></div>
          <TextField
            label="Tên Quỹ"
            onChange={(e) => handleChange(quyIdx, "tenQuy", e.target.value)}
            value={quy.tenQuy}
          ></TextField>
        </Stack>
      </Grid>
      <div style={{ width: "1rem" }}></div>
      <Grid size={{ xs: 12, sm: 4 }}>
        <TextField
          label="Ghi chú"
          onChange={(e) => handleChange(quyIdx, "note", e.target.value)}
          value={quy.note}
        ></TextField>
      </Grid>
      <div style={{ width: "1rem" }}></div>
      <Grid size={{ xs: 12, sm: 4 }}>
        <Stack direction={"row"}>
          <Button size="small" onClick={() => handleEdit(quyIdx)}>
            {"Sửa"}
          </Button>
          <Button size="small" onClick={() => handleDelete(quyIdx)}>
            {"Xóa"}
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}

function renderQuy(quy, handleChange, quyIdx, handleEdit, handleDelete) {
  return (
    <Stack
      spacing={{ xs: 1, sm: 2 }}
      direction="row"
      
      sx={{ flexWrap: "wrap", width: 1 }}
    >
      <Stack
        direction={"row"}
        spacing={{ xs: 1, sm: 2 }}
        width={{ xs: 1, sm: 300 }}
      >
        <TextField
          label="Ms Quỹ"
          sx={{ width: 100 }}
          value={quy.msQuy}
          onChange={(e) => handleChange(quyIdx, "msQuy", e.target.value)}
        />
        <TextField
          fullWidth
          label="Tên Quỹ"
          onChange={(e) => handleChange(quyIdx, "tenQuy", e.target.value)}
          value={quy.tenQuy}
        ></TextField>
      </Stack>
      <Stack
        direction={"row"}
        spacing={{ xs: 1, sm: 2 }}
        width={{ xs: 1, sm: 300 }}
      >
        <FormControl sx={{ width: 150 }}>
          <InputLabel id="demo-multiple-checkbox-label">
            {"Thành phần"}
          </InputLabel>
          <Select
            width="0.5"
            size="small"
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={quy.tp.split(",")}
            onChange={(e) =>
              handleChange(quyIdx, "tp", e.target.value.join(","))
            }
            input={<OutlinedInput label={"Thành phần"} />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {["A", "B", "C"].map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={quy.tp.split(",").includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ width: 150 }}>
          <InputLabel id="demo-select-small-label">{"Quản lý"}</InputLabel>
          <Select
            style={
              quy.private
                ? { backgroundColor: theme.palette.warning.light }
                : {}
            }
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={quy.private}
            label="Quản lý"
            onChange={(e) => handleChange(quyIdx, "private", e.target.value)}
          >
            <MenuItem value={true}>{"Có"}</MenuItem>
            <MenuItem value={false}>{"Không"}</MenuItem>
          </Select>
        </FormControl>
      </Stack>
      <Stack
        direction={"row"}
        spacing={{ xs: 1, sm: 2 }}
        width={{ xs: 1, sm: 200 }}
      >
        <TextField
          fullWidth
          label="Ghi chú"
          onChange={(e) => handleChange(quyIdx, "note", e.target.value)}
          value={quy.note}
        ></TextField>
      </Stack>
      <Stack
        direction={"row"}
        spacing={{ xs: 1, sm: 2 }}
        width={{ xs: 1, sm: 200 }}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <FormControlLabel
          sx={{ width: 100 }}
          control={
            <Checkbox
              checked={quy.khoa ? true : false}
              inputProps={{ "aria-label": "controlled" }}
              onChange={(e) => handleChange(quyIdx, "khoa", e.target.checked)}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            />
          }
          label="Khóa"
        />
        <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
          <Button
            sx={{ width: 50 }}
            size="small"
            onClick={() => handleEdit(quyIdx)}
          >
            {"Sửa"}
          </Button>
          <ConfirmButton
            sx={{ width: 50 }}
            onOk={() => handleDelete(quyIdx)}
            title={"Xác nhận xóa"}
            message={"Bạn có muốn xóa không? (Ấn [Có] để xóa quỹ)"}
          >
            <Button size="small">{"Xóa"}</Button>
          </ConfirmButton>
        </Stack>
      </Stack>
    </Stack>
  );
}
